import { BooleanAttributeChangedMixin, ChameleonPrefixedMixin, ChameleonVersionMixin, } from './ChameleonElement';
export function ChameleonElementMixin(Base) {
    return ChameleonVersionMixin('@getgo/chameleon-web 3.42.3')(BooleanAttributeChangedMixin(Base));
}
export function ChameleonPrefixedElementMixin(Base, baseName = '[DEFAULT_NAME]') {
    return ChameleonElementMixin(ChameleonPrefixedMixin(baseName)(Base));
}
